import React from "react";
import { Box, CardContent, Typography } from "@mui/material";

import ListCategories from "../Category/ListCategories";

function ActivityCategoryContent({ activity }) {
    const categoryCount = !!activity?.categories?.length
        ? activity.categories.length
        : 0;

    return (
        <CardContent>
            {categoryCount > 0 ? (
                <ListCategories categories={activity.categories} />
            ) : (
                <Box className="card-content">
                    <Typography variant="h3" component="h3">
                        Categories
                    </Typography>
                    <Typography variant="body1">
                        This activity is not linked to any categories.
                    </Typography>
                </Box>
            )}
        </CardContent>
    );
}

export default ActivityCategoryContent;
